var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
    "dismiss": `Revocare`
};


export {$93562b5094072f54$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
